import { render, staticRenderFns } from "./PromptDialog.vue?vue&type=template&id=06cc1c80&scoped=true&"
import script from "./PromptDialog.vue?vue&type=script&lang=ts&"
export * from "./PromptDialog.vue?vue&type=script&lang=ts&"
import style0 from "./PromptDialog.vue?vue&type=style&index=0&id=06cc1c80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06cc1c80",
  null
  
)

export default component.exports